import type { Category } from '@/types/content';

export const categories: Category[] = [
  {
    slug: 'yulequan',
    name: '娱乐圈',
    shortName: '娱乐圈',
    description: '剧集、影视与艺人动向的话题合集',
    intro:
      '从热播剧集的宣发节奏，到艺人与团队的协作方式，这里把娱乐圈里值得讨论的现象整理成专题。我们不爆料具体私人生活，只梳理公开信息背后可以理解、可以讨论的行业规律。',
    icon: 'ri-movie-2-line',
    tone: 'primary',
    keywords: ['娱乐圈', '影视话题', '剧集观察', '艺人动向'],
  },
  {
    slug: 'wanghongquan',
    name: '网红圈',
    shortName: '网红圈',
    description: '内容创作者与直播生态观察',
    intro:
      '网红圈的话题往往更新得很快，我们更关注那些能沉淀下来的规律：内容形态怎么演变、直播间如何运营、探店类账号为什么集中出现。看懂了机制，再吃瓜就不会只看到表面。',
    icon: 'ri-live-line',
    tone: 'accent',
    keywords: ['网红圈', '直播生态', '内容创作者', '账号运营'],
  },
  {
    slug: 'suren-gua',
    name: '素人瓜',
    shortName: '素人瓜',
    description: '普通人被关注后的那些故事',
    intro:
      '素人瓜的主角是普通人：一次偶遇、一段视频、一个意外走红。这个分区记录普通人被聚光灯照到之后发生了什么，也讨论围观者应有的分寸感。',
    icon: 'ri-user-voice-line',
    tone: 'secondary',
    keywords: ['素人瓜', '普通人故事', '偶遇明星', '意外走红'],
  },
  {
    slug: 'hangye-miwen',
    name: '行业秘闻',
    shortName: '行业秘闻',
    description: '台前之外的运作逻辑拆解',
    intro:
      '行业秘闻不是耸动的内幕，而是把台前的热闹翻译成后台的逻辑：选品规则、算法更替、宣发预算、内容排期。理解了运作方式，很多“看不懂”的话题就顺了。',
    icon: 'ri-spy-line',
    tone: 'primary',
    keywords: ['行业秘闻', '运作机制', '选品规则', '算法更替'],
  },
  {
    slug: 'zongyi-xianchang',
    name: '综艺现场',
    shortName: '综艺现场',
    description: '节目幕后与现场氛围解读',
    intro:
      '一档综艺好不好看，往往在现场就决定了一大半。这个分区聊分组逻辑、聊剪辑取舍、聊现场氛围是怎么被设计出来的，帮你看懂节目组的每一次取舍。',
    icon: 'ri-mic-line',
    tone: 'accent',
    keywords: ['综艺现场', '节目幕后', '剪辑逻辑', '现场氛围'],
  },
];